import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

interface ComparisonSectionProps {
  title?: string;
  columns?: string[];
  rows?: string[][];
}

const ComparisonSection: React.FC<ComparisonSectionProps> = ({ title = 'Compare Plans', columns, rows }) => {
  if (!columns || columns.length === 0 || !rows || rows.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        {title}
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((column, idx) => (
                <TableCell key={`${column}-${idx}`} sx={{ fontWeight: 700 }}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rIdx) => (
              <TableRow key={`row-${rIdx}`}>
                {row.map((cell, cIdx) => (
                  <TableCell key={`${cell}-${cIdx}`} sx={{ color: cIdx === 0 ? 'text.primary' : 'text.secondary' }}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default React.memo(ComparisonSection);
